@if ((isImpersonator | async) === false) {
    <div [matMenuTriggerFor]="menu" class="menu-trigger">
        <ng-container i18n="@@menu.myMenu">Mein Konto</ng-container>@if (accountName | async; as name) {: {{name}}}<app-icon name="chevron_down" />
    </div>

    <mat-menu #menu="matMenu" xPosition="after" yPosition="below">
        <button mat-menu-item
                [routerLink]="'/authentication/change-email'"
                i18n="@@menu.changeEmailButton">
            E-Mail-Adresse ändern
        </button>
        <button mat-menu-item
                [routerLink]="'/authentication/change-password'"
                i18n="@@menu.changePasswordButton">
            Passwort ändern
        </button>
        <button mat-menu-item
                (click)="onLogout()"
                i18n="@@action.logout">
            Abmelden
        </button>
    </mat-menu>
} @else {
    <a (click)="onRestoreOriginalUser()">
        <ng-container i18n="@@menu.restoreOriginalUserLink">
            Benutzer verlassen
        </ng-container>
        <app-icon class="loginAs" name="login_as" />
    </a>
}
